module.exports = __webpack_public_path__ + "assets/logo.d50530c1.svg";